import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import Navigation from './app/shell/Navigation';
import AppRouter from './app/router/AppRouter';
import RouteMeta from './app/seo/RouteMeta';
import SplashScreen from './components/SplashScreen';
import ConsentBanner from './components/ConsentBanner';
import './App.css';

function AppShell() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const isCheckoutRedirectPath = location.pathname === '/hidden/checkout/9B600ce30cGGdF63N2gQE03';

  useEffect(() => {
    const ua = navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/.test(ua);
    const isWebkit = /WebKit/.test(ua);
    const isCriOS = /CriOS/.test(ua);
    const isFxiOS = /FxiOS/.test(ua);
    const isSafari = isIOS && isWebkit && !isCriOS && !isFxiOS;

    if (isSafari) {
      document.documentElement.classList.add('ios-safari');
    }

    return () => {
      document.documentElement.classList.remove('ios-safari');
    };
  }, []);

  useEffect(() => {
    // Hide splash screen after initial load
    const timer = setTimeout(() => setIsLoading(false), 2400);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    document.body.classList.toggle('app-loading', isLoading);
    return () => document.body.classList.remove('app-loading');
  }, [isLoading]);

  return (
    <>
      <RouteMeta />
      {!isCheckoutRedirectPath && <SplashScreen isLoading={isLoading} />}
      {!isCheckoutRedirectPath && <Navigation />}
      <AppRouter />
      <ConsentBanner />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;
